// Copyright (c) Ping. All rights reserved.
//
// Helper for the new unified "Email or phone number" input on the
// Login / Create-account screens. The user types into one field and we
// pick the email vs. phone path before dispatching the FSM transition.
//
// Pure (no IO, no clock); composes the existing validators in
// authValidators.ts.

import { validateEmail, validatePhone } from './authValidators';

export type ContactKind = 'email' | 'phone' | 'unknown';

/**
 * Returns the kind of contact value the user typed. Resolution order:
 *
 *  1. If the input contains an `@`, treat it as an email candidate and
 *     let `validateEmail` arbitrate.
 *  2. Otherwise treat it as a phone candidate.
 *  3. If neither validator accepts the input, return `'unknown'` so
 *     the caller can surface a generic "invalid email or phone" error.
 */
export function detectContactKind(input: string): ContactKind {
	const trimmed = input.trim();
	if (trimmed.length === 0) return 'unknown';

	if (trimmed.includes('@')) {
		return validateEmail(trimmed).ok ? 'email' : 'unknown';
	}

	return validatePhone(trimmed).ok ? 'phone' : 'unknown';
}
